import { Reveal, Overline } from "./Reveal";
import { useLang } from "@/i18n";
import { CheckCircle2 } from "lucide-react";

export const About = () => {
  const { t } = useLang();
  const points = t("about.points");
  return (
    <section id="about" className="py-32 lg:py-40 border-b border-white/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        <Reveal className="lg:col-span-7">
          <Overline>{t("about.overline")}</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t("about.title")}</h2>
          <p className="mt-8 text-steel-400 leading-relaxed text-base lg:text-lg">{t("about.text")}</p>
          <p className="mt-4 text-steel-400 leading-relaxed">{t("about.text2")}</p>
          <ul className="mt-10 space-y-4">
            {points.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-steel-300" data-testid={`about-point-${i}`}>
                <CheckCircle2 size={18} className="text-ember shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="relative overflow-hidden border border-white/10">
            <img src="/about.jpg" alt="Sodimax Logistics — Montréal" loading="lazy" decoding="async" className="w-full aspect-[4/5] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-abyss via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 p-8">
              <p className="font-display text-6xl font-bold text-ember" data-testid="about-year">2014</p>
              <p className="text-xs uppercase tracking-widest text-steel-400 mt-2">{t("about.since")}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
